export function countChipsOnFirstRow(widths: readonly number[], available: number, gap: number, toggleWidth: number): number {
  const allChipsWidth = widths.reduce((sum, width) => sum + width, 0) + gap * Math.max(0, widths.length - 1);
  if (allChipsWidth <= available) {
    return widths.length;
  }
  let used = 0;
  let count = 0;
  for (const width of widths) {
    used += width;
    if (used + (count + 1) * gap + toggleWidth > available) {
      break;
    }
    count++;
  }
  return count;
}
